import { render, staticRenderFns } from "./searchMarkDetail.vue?vue&type=template&id=6c1a69c0&"
import script from "./searchMarkDetail.vue?vue&type=script&lang=js&"
export * from "./searchMarkDetail.vue?vue&type=script&lang=js&"
import style0 from "./searchMarkDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c1a69c0')) {
      api.createRecord('6c1a69c0', component.options)
    } else {
      api.reload('6c1a69c0', component.options)
    }
    module.hot.accept("./searchMarkDetail.vue?vue&type=template&id=6c1a69c0&", function () {
      api.rerender('6c1a69c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/DocumentCirculation/searchMarkDetail.vue"
export default component.exports